import { ArrowDown } from "lucide-react";
import type { DownArrowProps } from "../[clientSlug]/types";

const DEFAULT_COLOR = "white";

// Render config is untyped ops JSON fetched without validation, so props may
// be missing, null, or carry a non-string color.
const resolveColor = (props: DownArrowProps | null | undefined) => {
  const color = props?.color;
  if (typeof color !== "string") return DEFAULT_COLOR;
  const trimmed = color.trim();
  return trimmed === "" ? DEFAULT_COLOR : trimmed;
};

export const ArrowDownCustomComponent = ({
  style,
  props,
}: {
  style: string;
  props?: DownArrowProps | null;
}) => {
  return (
    <>
      <ArrowDown
        color={resolveColor(props)}
        size={36}
        className={style}
        key={"arrow-down-component"}
      />
    </>
  );
};
